import React from 'react'
import { Region } from '@enonic/react-components';

import { ArticleLayoutProps } from './article.d';

import Article from '/react4xp/components/pages/article'

function ArticleLayout(props: ArticleLayoutProps) {
    return (
        <Article
            {...props}
            bottomRegion={<Region name={props.regions.bottom.name} regionData={props.regions.bottom} />}
        />
    )
}

export default (props) => <ArticleLayout {...props} />